import { Button, Input, Table, Pagination } from "antd";
import { SearchIcon } from "@/shared/assets/svg/icons";
import "./notification-history-content.scss";

const mockHistoryData = [
  {
    id: "history-1",
    date: "27.12.2023",
    time: "12:30 GMT+3",
    event: "Отправлено на согласование",
    section: "Титульный лист",
    status: "Отправлено",
    employee: { name: "Застроев Г. А.", position: "Начальник" },
    comment: "Пойдет",
  },
  {
    id: "history-2",
    date: "26.12.2023",
    time: "14:15 GMT+3",
    event: "Создано уведомление",
    section: "Раздел 3",
    status: "Создано",
    employee: { name: "Петров И. С.", position: "Инженер" },
    comment: "Требует доработки",
  },
  {
    id: "history-3",
    date: "25.12.2023",
    time: "09:45 GMT+3",
    event: "Принято к рассмотрению",
    section: "Титульный лист",
    status: "Принято",
    employee: { name: "Сидоров А. В.", position: "Эксперт" },
    comment: "Все в порядке",
  },
  {
    id: "history-4",
    date: "24.12.2023",
    time: "16:20 GMT+3",
    event: "Отклонено",
    section: "Раздел 2",
    status: "Отклонено",
    employee: { name: "Иванов М. П.", position: "Контролер" },
    comment: "Нужны исправления",
  },
];

export function NotificationHistoryContent() {
  const columns = [
    {
      title: "Дата, время",
      key: "datetime",
      render: (_: any, record: any) => (
        <div>
          <div className="notification-history-content__date">{record.date}</div>
          <div className="notification-history-content__time">{record.time}</div>
        </div>
      ),
    },
    {
      title: "Событие",
      dataIndex: "event",
      key: "event",
    },
    {
      title: "Раздел",
      dataIndex: "section",
      key: "section",
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Сотрудник",
      key: "employee",
      render: (_: any, record: any) => (
        <div className="notification-history-content__employee">
          <Button
            type="link"
            style={{ padding: 0, height: "auto", textAlign: "left" }}
          >
            {record.employee.name}
          </Button>
          <div className="notification-history-content__employee-position">
            {record.employee.position}
          </div>
        </div>
      ),
    },
    {
      title: "Комментарий",
      dataIndex: "comment",
      key: "comment",
    },
  ];

  return (
    <div className="notification-history-content">
      <div className="notification-history-content__file-section">
        <div className="notification-history-content__search">
          <Input
            placeholder="Поиск"
            suffix={<SearchIcon />}
            style={{ width: 240 }}
          />
        </div>

        <Table
          className="notification-history-content__table"
          rowKey={(row) => row.id}
          dataSource={mockHistoryData}
          columns={columns}
          pagination={false}
        />
      </div>

      <Pagination
        current={1}
        total={mockHistoryData.length}
        pageSize={10}
        showSizeChanger
        showTotal={(total, range) => `${range[0]}-${range[1]} из ${total}`}
        pageSizeOptions={["10", "20", "50", "100"]}
        className="notification-history-content__pagination"
        onChange={() => {}}
        onShowSizeChange={() => {}}
      />

    </div>
  );
}

